import type { FC } from 'react';

import { Tag } from '@crehana/compass.ui/v3/tag';

import useTeamCoursesTranslation from '../../hooks/useTeamCoursesTranslation/useTeamCoursesTranslation';
import { humanizeExpirationDate } from '../../utils';

export type TTrackClosureTagProps = {
  closedAt?: string | null;
};

export const TrackClosureTag: FC<TTrackClosureTagProps> = ({ closedAt }) => {
  const { t, languageCode } = useTeamCoursesTranslation();

  return (
    <>
      <Tag variant="alert" className="tw-w-fit">
        {t('LEARN_TEAM_HEADER_DETAIL_ROUTE_CLOSED_TAG')}
      </Tag>
      {closedAt && (
        <span className="tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500 tw-mt-0.4 tw-whitespace-nowrap">
          {t('LEARN_TEAM_HEADER_DETAIL_ROUTE_CLOSED_DATE', {
            interpolation: {
              date:
                humanizeExpirationDate(closedAt, {
                  languageCode,
                  outputFormat: 'DD/MM/YYYY',
                }) || '',
            },
          })}
        </span>
      )}
    </>
  );
};
